import configureStore from './app/store';

import SocketClient from "./services/io.service";
const socketClient = new SocketClient();
const store = configureStore(socketClient);
export default store;